export default "<input class=\"js-display-value\" placeholder=\"<%- placeholder %>\" />\n<div class=\"js-calendar-wrapper\"></div>\n";